import fetch from '../../../../core/fetch';
import showToaster from '../../../../helpers/toasterMessages/showToaster';
import { demoRestriction } from '../../../../helpers/DemoRestriction/demoRestriction';

async function submit(values, dispatch) {

  const isRestrict = await dispatch(demoRestriction({}));
  if (isRestrict) return;

  const query = `
  mutation (
    $earnBlockTitle1: String,
    $earnBlockContent1: String,
    $dynamicWhyHostInfoBlock: String
) {
  updateWhyHostPage (
    earnBlockTitle1: $earnBlockTitle1,
    earnBlockContent1: $earnBlockContent1,
    dynamicWhyHostInfoBlock: $dynamicWhyHostInfoBlock
  ) {
      status
  }
}

  `;

  const resp = await fetch('/graphql', {
    method: 'post',
    headers: {
      Accept: 'application/json',
      'Content-Type': 'application/json'
    },
    body: JSON.stringify({
      query: query,
      variables: {
        earnBlockTitle1: values.dynamicWhyHostInfoBlock[0].earnBlockTitle1,
        earnBlockContent1: values.dynamicWhyHostInfoBlock[0].earnBlockContent1,
        dynamicWhyHostInfoBlock: JSON.stringify(values.dynamicWhyHostInfoBlock),
      }
    }),
    credentials: 'include',
  });

  const { data } = await resp.json();

  if (data?.updateWhyHostPage?.status === "success") {
    showToaster({ messageId: 'updateWhyHostPage', toasterType: 'success' })
  } else {
    showToaster({ messageId: 'updateWhyHostPageFailed', toasterType: 'error' })
  }

}

export default submit;
